<template>
    <div class="anagrafica_quickconnext" style="margin: 20px">
        <v-card>
            <v-toolbar dense color="primary" dark align="center">
                <v-row class="mt-4">
                    <v-col cols="3" align="left" class="mt-1">
                        <v-toolbar-title
                            >Anagrafica QuickConnext</v-toolbar-title
                        >
                    </v-col>
                    <v-col cols="1" class="mt-1">
                        <v-btn
                            small
                            light
                            @click="updateConfigMulti"
                            v-if="multiMode"
                        >
                            <v-icon color="success">mdi-check</v-icon>
                        </v-btn>
                    </v-col>
                    <v-col cols="1" class="mt-1">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    small
                                    light
                                    @click="multiMode = !multiMode"
                                >
                                    <v-icon
                                        v-bind="attrs"
                                        v-on="on"
                                        color="purple"
                                        >mdi-upload-multiple</v-icon
                                    >
                                </v-btn>
                            </template>
                            <span>Aggiornamento multipla</span>
                        </v-tooltip>
                    </v-col>
                    <v-col cols="1" class="mt-1">
                        <v-btn small light @click="setAnagrafica">
                            <v-icon color="success">mdi-floppy</v-icon>
                        </v-btn>
                    </v-col>
                    <v-col cols="1" class="mt-1" align="left">
                        <v-btn
                            small
                            light
                            @click="$refs.dialog_anagrafica.apri(null)"
                        >
                            <v-icon color="primary">mdi-plus</v-icon>
                        </v-btn>
                    </v-col>
                    <!--v-col cols="1" class="mt-1">
            <v-btn
              :disabled="selectedDevices.length == 0"
              small
              light
              @click="updateDevices()"
            >
              <v-icon color="purple">mdi-tray-arrow-up</v-icon>
            </v-btn>
          </v-col -->
                    <v-col cols="3">
                        <v-text-field
                            v-model="filter"
                            solo
                            dense
                            append-icon="mdi-magnify"
                            clearable
                            light
                            placeholder="Filtra"
                        ></v-text-field>
                    </v-col>

                    <v-col cols="1" align="right" class="mt-1">
                        <v-btn small light @click="refresh">
                            <v-icon color="primary">mdi-autorenew</v-icon>
                        </v-btn>
                    </v-col>
                    <v-col cols="1" align="right" class="mt-1">
                        <v-btn small light @click="$router.push('/home')">
                            <v-icon color="error"
                                >mdi-keyboard-backspace</v-icon
                            >
                        </v-btn>
                    </v-col>
                </v-row>
            </v-toolbar>
            <v-container v-if="clienti != null && dispositivi != null">
                <v-data-table
                    :key="render"
                    :headers="testata"
                    :items="filtraDispositivi(filter)"
                    disable-pagination
                    hide-default-footer
                >
                    <!-- Bottone aggiorna -->
                    <template v-slot:[`item._update`]="{ item }">
                        <v-checkbox
                            v-if="multiMode"
                            v-model="item.selected"
                            dense
                        ></v-checkbox>
                        <v-btn
                            v-else
                            icon
                            small
                            @click="aggiornaConfigurazione(item.device_id)"
                        >
                            <v-icon color="teal">mdi-progress-upload</v-icon>
                        </v-btn>
                    </template>

                    <!-- Bottone esporta -->
                    <template v-slot:[`item._export`]="{ item }">
                        <v-btn
                            icon
                            small
                            @click="esportaConfigurazione(item.device_id)"
                        >
                            <v-icon color="purple">mdi-export</v-icon>
                        </v-btn>
                    </template>

                    <!-- Bottone impostazioni -->
                    <template v-slot:[`item._manage`]="{ item }">
                        <v-btn
                            icon
                            small
                            @click="$refs.dialog_anagrafica.apri(item)"
                        >
                            <v-icon color="blue-grey">mdi-cog</v-icon>
                        </v-btn>
                    </template>

                    <!-- Bottone impostazioni -->
                    <template v-slot:[`item._assistenza`]="{ item }">
                        <v-btn
                            icon
                            small
                            @click="ToggleAssistenza(item)"
                            v-if="item?.flag_ssh == 1"
                        >
                            <v-icon
                                :color="
                                    item.assistenza == 1 &&
                                    item.canale_attivo == 1
                                        ? 'success'
                                        : item.assistenza == 1
                                        ? 'amber'
                                        : 'error'
                                "
                                >mdi-lifebuoy</v-icon
                            >
                        </v-btn>
                    </template>

                    <!-- Bottone chiavi -->
                    <template v-slot:[`item._key`]="{ item }">
                        <v-btn
                            icon
                            small
                            @click="$refs.dialog_token.promptPassword(item)"
                        >
                            <v-icon color="warning">mdi-key</v-icon>
                        </v-btn>
                    </template>

                    <!-- Tipo piattaforma -->
                    <template v-slot:[`item.tipo_piattaforma`]="{ item }">
                        {{ getPiattaforma(item.tipo_piattaforma) }}
                    </template>

                    <!-- Icona attivo -->
                    <template v-slot:[`item.enabled`]="{ item }">
                        <v-icon
                            :color="item.enabled == 1 ? 'success' : 'error'"
                            >{{
                                item.enabled == 1 ? "mdi-check" : "mdi-close"
                            }}</v-icon
                        >
                    </template>

                    <!-- Icona online -->
                    <template v-slot:[`item.online`]="{ item }">
                        <v-icon
                            :color="item.online == true ? 'success' : 'error'"
                            >{{
                                item.online == true ? "mdi-check" : "mdi-close"
                            }}</v-icon
                        >
                    </template>

                    <!-- Cliente -->
                    <template v-slot:[`item.id_azienda`]="{ item }">
                        {{ getAzienda(item.id_azienda) }}
                    </template>
                </v-data-table>
            </v-container>
        </v-card>

        <DialogAnagraficaQuickConnext
            ref="dialog_anagrafica"
            :clienti="clienti"
            :dispositivi="dispositivi"
            :piattaforme="piattaforme"
        />
        <DialogTokenAnagraficaQuickConnext ref="dialog_token" />

        <v-dialog persistent width="400" v-model="alert.mostra">
            <v-card>
                <v-container>
                    <v-row align="center" justify="center">
                        <v-col cols="1" align="center">
                            <v-icon large>{{ alert.icona }}</v-icon>
                        </v-col>
                        <v-col cols="11">
                            <h3
                                style="
                                    word-break: keep-all;
                                    text-align: left;
                                    padding: 0 20px;
                                "
                            >
                                {{ alert.messaggio }}
                            </h3>
                        </v-col>
                    </v-row>
                </v-container>
                <v-card-actions>
                    <v-spacer />
                    <v-btn text color="primary" @click="alert.mostra = false"
                        >Ok</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="caricamento" persistent width="350">
            <v-card>
                <v-container>
                    <v-progress-circular
                        indeterminate
                        color="primary"
                        size="200"
                        style="margin: 50px"
                    ></v-progress-circular>
                </v-container>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import DialogAnagraficaQuickConnext from "./DialogAnagraficaQuickConnext.vue";
import DialogTokenAnagraficaQuickConnext from "./DialogTokenAnagraficaQuickConnext.vue";
export default {
    name: "AnagraficaQuickConnext",
    components: {
        DialogAnagraficaQuickConnext,
        DialogTokenAnagraficaQuickConnext,
    },
    data() {
        return {
            caricamento: false,
            multiMode: false,
            alert: {
                icona: null,
                messaggio: null,
                mostra: false,
            },
            clienti: null,
            dispositivi: null,
            tmp_dispositivi: null,
            render: 0,
            filter: null,
            selectedDevices: [],
            NETWORK: null,
            piattaforme: null,
            testata: [
                { text: null, value: "_update" },
                { text: null, value: "_export" },
                { text: null, value: "_manage" },
                { text: null, value: "_key" },
                { text: null, value: "_assistenza" },
                { text: "Id", value: "device_id" },
                { text: "Nome dispositivo", value: "device_name" },
                { text: "Cliente", value: "id_azienda" },
                { text: "Seriale", value: "serial" },
                { text: "Piattaforma", value: "tipo_piattaforma" },
                { text: "Attivo", value: "enabled" },
                { text: "Online", value: "online" },
                { text: "Tipo Box", value: "tipo_box" },
                { text: "Versione Core", value: "versione_core" },
                { text: "Ultimo Aggiornamento", value: "ultimo_aggiornamento" },
                //{ text: "Update Status", value: "update_status" },
            ],
        };
    },
    mounted() {
        this.NETWORK = this.$store.state.Network;
        this.refresh();
    },
    methods: {
        ToggleAssistenza(arg) {
            if (arg.assistenza == 1) {
                arg.assistenza = 0;
            } else {
                arg.assistenza = 1;
            }
            this.setAnagrafica();
        },
        aggiornaChiavi(device_id) {
            const that = this;
            const request = {
                controller: "quickconnext",
                endpoint: "connext",
                response: { parse: false },
                showdialog: false,
                body: {
                    action: "updatedevicekey",
                    token: localStorage.user_token,
                    device_id: device_id,
                },
                method: "PUT",
                on: {
                    load: function () {
                        Object.assign(that.alert, {
                            icona: "mdi-shield-check",
                            messaggio: "Chiavi aggiornate correttamente",
                            mostra: true,
                        });
                    },
                    error: function (response) {
                        response = response.target;
                        Object.assign(that.alert, {
                            icona: "mdi-alert-box",
                            messaggio: response.responseText,
                            mostra: true,
                        });
                    },
                },
            };
            this.NETWORK.AjaxRequest(request);
        },
        async updateConfigMulti() {
            for (const d of this.dispositivi.filter(
                (e) => e.selected == true
            )) {
                await this.aggiornaConfigurazione(d.device_id);
            }
            this.multiMode = false;
        },
        async aggiornaConfigurazione(device_id) {
            this.caricamento = true;
            let request = {
                controller: "global",
                method: "PUT",
                richiesta: {
                    action: "updatedeviceconfig",
                    token: localStorage.user_token,
                    device_id: device_id,
                },
            };

            await this.$store
                .dispatch("api6", request)
                .then((res) => {
                    console.log(res);
                    Object.assign(this.alert, {
                        icona: "mdi-check-network",
                        messaggio:
                            "Refresh configurazione eseguito correttamente",
                        mostra: true,
                    });
                })
                .catch((err) => {
                    Object.assign(this.alert, {
                        icona: "mdi-alert-box",
                        messaggio: err,
                        mostra: true,
                    });
                });
            this.caricamento = false;
            /*const that = this;
            const request = {
                controller: "quickconnext",
                endpoint: "connext",
                response: { parse: false },
                showdialog: false,
                body: {
                    action: "updatedeviceconfig",
                    token: localStorage.user_token,
                    device_id: device_id,
                },
                method: "PUT",
                on: {
                    load: function () {
                        Object.assign(that.alert, {
                            icona: "mdi-check-network",
                            messaggio:
                                "Refresh configurazione eseguito correttamente",
                            mostra: true,
                        });
                    },
                    error: function (response) {
                        response = response.target;
                        Object.assign(that.alert, {
                            icona: "mdi-alert-box",
                            messaggio: response.responseText,
                            mostra: true,
                        });
                    },
                },
            };
            await this.NETWORK.AjaxRequest(request);*/
        },
        async esportaConfigurazione(device_id) {
            this.caricamento = true;
            let request = {
                controller: "global",
                method: "POST",
                richiesta: {
                    action: "exportconfig",
                    token: localStorage.user_token,
                    device_id: device_id,
                },
            };

            await this.$store
                .dispatch("api6", request)
                .then((res) => {
                    const blob = new Blob([JSON.stringify(res.data.result)], {
                        type: "text/plain",
                    });
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.href = url;
                    a.download = "config.json";
                    a.click();
                })
                .catch((err) => {
                    Object.assign(this.alert, {
                        icona: "mdi-alert-box",
                        messaggio: err,
                        mostra: true,
                    });
                });
            this.caricamento = false;
        },
        filtraDispositivi(filter) {
            if ((filter || "").trim() == "") {
                return this.dispositivi;
            }
            const result = new Array();
            this.dispositivi.forEach((device) => {
                if (
                    (device.device_name || "")
                        .toLowerCase()
                        .indexOf(filter.toLowerCase().trim()) >= 0
                ) {
                    result.push(device);
                }
            });
            return result;
        },
        async getAnagrafica() {
            this.caricamento = true;
            const request = {
                controller: "global",
                method: "POST",
                richiesta: {
                    action: "getdevicelist",
                    token: localStorage.user_token,
                },
            };
            await this.$store.dispatch("api6", request).then((response) => {
                this.dispositivi = response.data.result;
                for (var d of this.dispositivi) {
                    d.selected = false;
                }
                this.tmp_dispositivi = this.dispositivi;
            });
            this.caricamento = false;
        },
        getAzienda(id) {
            for (let i = 0; i < this.clienti.length; i++) {
                const azienda = this.clienti[i];
                if (azienda.id_azienda == id) {
                    return azienda.ragione_sociale;
                }
            }
            return null;
        },
        getAziende() {
            const that = this;
            const request = {
                controller: "Modulo",
                body: {
                    action: "getAzienda",
                    token: localStorage.user_token,
                },
                method: "POST",
                on: {
                    load: function (response) {
                        that.clienti = response.azienda;
                    },
                },
            };
            this.NETWORK.AjaxRequest(request);
        },
        getPiattaforma(id) {
            if (this.piattaforme == null) {
                return null;
            }
            for (let i = 0; i < this.piattaforme.length; i++) {
                const piattaforma = this.piattaforme[i];
                if (piattaforma.id_piattaforma == id) {
                    return piattaforma.nome;
                }
            }
            return null;
        },
        getPiattaforme() {
            const that = this;
            this.piattaforme = null;
            const request = {
                controller: "quickconnext",
                endpoint: "connext",
                response: { parse: false },
                body: {
                    action: "getplatforms",
                    token: localStorage.user_token,
                },
                method: "POST",
                on: {
                    load: function (response) {
                        that.piattaforme = JSON.parse(response).piattaforme;
                    },
                },
            };
            this.NETWORK.AjaxRequest(request);
        },
        refresh() {
            this.getAziende();
            this.getAnagrafica();
            this.getPiattaforme();
        },
        setAnagrafica() {
            const that = this;
            const request = {
                controller: "quickconnext",
                endpoint: "connext",
                body: {
                    action: "setdeviceinfo",
                    token: localStorage.user_token,
                    devices: this.dispositivi,
                },
                response: { parse: false },
                method: "PUT",
                on: {
                    load: that.getAnagrafica,
                },
            };
            this.NETWORK.AjaxRequest(request);
        },
        updateDevices() {
            console.log("selectedDevices:", this.selectedDevices);
            /*this.$SSEController.addEventListener(
                "update_device_status",
                this.updateDeviceStatus
            );*/
            const that = this;
            const request = {
                controller: "quickconnext",
                endpoint: "connext",
                body: {
                    action: "updatedevices",
                    token: localStorage.user_token,
                    devices: this.selectedDevices,
                },
                response: { parse: false },
                method: "PUT",
                on: {
                    load: that.removeEventListener,
                },
            };
            this.NETWORK.AjaxRequest(request);
        },
        updateDeviceStatus(response) {
            let data = JSON.parse(response.data);
            console.log(data);
            // this.dispositivi.forEach(device => {
            //     if(device.id_device == data.id_dispositivo)
            //     {
            //         switch(data.id_fase)
            //         {
            //             case 0:
            //                 if(data.stato_fase)
            //                     device.update_status = "";
            //                 break;
            //         }
            //         this.render++;
            //     }
            // });
        },
        removeEventListener() {
            /*this.$SSEController.removeEventListener(
                "update_device_status",
                this.updateDeviceStatus
            );*/
        },
    },
};
</script>
